
import { Component, Vue } from 'vue-property-decorator';
import DeviceLayout from '../../layouts/DeviceLayout.vue';
import PcPage from '../../blocks/PcPage.vue';
import MobilePage from '../../blocks/MobilePage.vue';
import { SO360_01_DOWNLOAD_URLS, S360_DOWNLOAD_CONFIGS } from '../../config/downloadUrls';
import { LandingProps } from '../../config/types';
import { setupPage } from '../../utils/setupPage';

const DEVELOPER_NAME = '浙江闲趣互娱网络科技有限公司';

@Component({
  components: { DeviceLayout, PcPage, MobilePage },
})
export default class So36001Page extends Vue {
  public landingProps: LandingProps = {
    downloadUrls: SO360_01_DOWNLOAD_URLS,
    hideList: false,
    showAppInfo: true,
    isBaiduDeveloper: false,
    showAddress: false,
    developerName: DEVELOPER_NAME,
    so360DownloadConfig: S360_DOWNLOAD_CONFIGS.SO360_01,
  };

  public mounted() {
    setupPage({
      documentTitle: DEVELOPER_NAME,
      so360Tracking: false,
    });
  }
}
